import { render, staticRenderFns } from "./AddendaFieldsForm.vue?vue&type=template&id=62ef9622&scoped=true"
import script from "./AddendaFieldsForm.vue?vue&type=script&lang=js"
export * from "./AddendaFieldsForm.vue?vue&type=script&lang=js"
import style0 from "./AddendaFieldsForm.vue?vue&type=style&index=0&id=62ef9622&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef9622",
  null
  
)

export default component.exports